module.exports = __webpack_public_path__ + "static/media/at.7824152b.svg";